import { isApiError } from '@lib/api/utils/is-api-error';
import { isCallerProvablySignedOut } from '@lib/auth/clerk-session-bridge';
import { isSuppressSignedOutQuery401Enabled } from '@lib/query/utils/is-suppress-signed-out-query-401-enabled';

export function shouldSuppressSignedOutQueryError(
  error: Error,
  meta: Record<string, unknown> | undefined
): boolean {
  if (!isSuppressSignedOutQuery401Enabled()) return false;
  if (meta?.skipClerkRefresh === true) return false;
  if (!isCallerProvablySignedOut()) return false;
  return isApiError(error) && (error.status === 401 || error.status === 403);
}
